import React from 'react';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';

import { adalApiFetch } from './../store/adalConfig';
import { display } from '@material-ui/system';

// TODO - need to handle tab out of control to auto select first value

function renderInputComponent(inputProps) {
    const { classes, inputRef = () => { }, ref, ...other } = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);

    return (
        <MenuItem selected={isHighlighted} component="div">
            <div>
                {parts.map(part => (
                    <span key={part.text} style={{ fontWeight: part.highlight ? 500 : 400 }}>
                        {part.text}
                    </span>
                ))}
            </div>
        </MenuItem>
    );
}

function getSuggestions(value, url, setSuggestions, extraValue = undefined) {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;

    if (url === null || url === '' || inputLength === 0) {
        setSuggestions([]);
        return;
    }

    let _query = "?search=" + value + (extraValue !== undefined ? "&extraValue=" + extraValue : '');
    
    adalApiFetch(fetch, url + _query)
        .then(response => response.json())
        .then(data => {
            setSuggestions(data);     
        });
}

function getSuggestionValue(suggestion) {
    return suggestion.label;
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        margin: 4,
        display:'block',
    },
    hidden: {
        flexGrow: 1,
        margin: 4,
        display: 'none',
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    }
}));

export default function IntegrationAutosuggest({ inputId, label, placeholder, ajax, displayText, handleChange, handleSelected, displayType, extraValue}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [stateSuggestions, setSuggestions] = React.useState([]);

    const handleSuggestionsFetchRequested = ({ value }) => {
        getSuggestions(value, ajax, setSuggestions, extraValue)
    };

    const handleSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const handleOnSuggestionSelected = name => (event, { suggestion }) => {
        handleSelected(name + 'Text', suggestion.label, name + 'Value', suggestion.value );
    }

    const handleOnChange = name => (event, { newValue }) => {
        handleChange(name + 'Text', newValue);
    };  

    const autosuggestProps = {
        renderInputComponent,
        suggestions: stateSuggestions,
        onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
        onSuggestionsClearRequested: handleSuggestionsClearRequested,
        onSuggestionSelected: handleOnSuggestionSelected(inputId),
        getSuggestionValue,
        renderSuggestion,
        highlightFirstSuggestion: inputId === 'modalLotSearchSellerSelect'
    };

    const handleOnBlur = name => (event, { highlightedSuggestion }) => {
        if (name === 'modalLotSearchSellerSelect') {
            if (highlightedSuggestion) {
                handleSelected(name + 'Text', highlightedSuggestion.label, name + 'Value', highlightedSuggestion.value);
            }
        }
    }

    return (
        <div className={displayType === 'true' ? classes.root : classes.hidden}>
            <Autosuggest
                {...autosuggestProps}
                inputProps={{
                    classes,
                    id: inputId,
                    label: label,
                    placeholder: placeholder,
                    value: displayText,
                    onChange: handleOnChange(inputId),
                    onBlur: handleOnBlur(inputId),
                    inputRef: node => {
                        setAnchorEl(node);
                    },
                    InputLabelProps: {
                        shrink: true,
                    },
                }}
                theme={{
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion,
                }}
                renderSuggestionsContainer={options => (
                    <Popper anchorEl={anchorEl} open={Boolean(options.children)} style={{ zIndex: 3 }}>
                        <Paper
                            square
                            {...options.containerProps}
                            style={{ width: anchorEl ? anchorEl.clientWidth : undefined}}>
                            {options.children}
                        </Paper>
                    </Popper>
                )}
            />
        </div>
    );
}